import React, { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./Card.css";
import profile from "../../assets/images/profile.webp";
import emailIcon from "../../assets/images/email-icon.svg";
import phoneIcon from "../../assets/images/phone-icon.svg";
import loader from "../../assets/images/loader.gif";
import organisationIcon from "../../assets/images/organization-icon.svg";
import QRCode from "react-qr-code";
import vCardsJS from "vcards-js";

export default function Card(props) {
  //eslint-disable-next-line
  const [vCards, setVcard] = useState(vCardsJS());
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (props.id && !props.loading) {
      downloadVCard();
    }
  }, [props]);

  const downloadVCard = () => {
    let createCard = { ...vCards };

    createCard.firstName = props.fname.link;
    createCard.lastName = props.lname.link;
    createCard.organization = props.org.link;
    createCard.workPhone = props.phone.countryCode + " " + props.phone.link;
    createCard.email = props.email.link;
    createCard.title = props.title.link;
    setVcard(createCard);
    const hiddenElement = document.createElement("a");

    hiddenElement.href =
      "data:attachment/text/vcard," +
      encodeURI(createCard.getFormattedString());
    hiddenElement.target = "_blank";
    hiddenElement.download = `${props.fname.link + " " + props.lname.link}.vcf`;
    if (props.fname.link !== undefined && props.lname.link !== undefined) {
      hiddenElement.click();
    }

    setLoading(true);
  };

  return (
    <div className="align-center-card">
      {!props.active && (
        <>
          <div className="verification-box">
            <div className="fail-icon" />
            <div className="verification-text">
              <>
                <h1>{props.message}</h1>
              </>
            </div>
          </div>
        </>
      )}
      {props.active && (
        <>
          {props.success && (
            <h1 className="card-heading">Digital Business Card</h1>
          )}
          {!props.success ? (
            <div className="verification-box">
              <div className="fail-icon" />
              <div className="verification-text">
                <>
                  <h1>No Records Found</h1>
                  <h2>
                    Link is invalid. Please re-scan the QR code and open the
                    link.
                  </h2>
                </>
              </div>
            </div>
          ) : (
            <div className="profile-card">
              <div className="align-profile-box">
                <div className="profile-pic">
                  <ImageComponent
                    image={{
                      src:
                        props.profilePic && props.profilePic.trim() !== ""
                          ? props.profilePic
                          : profile,
                      alt: "profile pic",
                    }}
                  ></ImageComponent>
                  {/* <img
                // style={loaded ? {} : { display: "none" }}
                src={
                  props.profilePic && props.profilePic.trim() !== ""
                    ? "//" + props.profilePic.replace(/^https?:\/\//, "")
                    : profile
                }
                onLoad={() => setLoaded(true)}
                alt="profile pic"
              /> */}
                </div>
                <div className="head-content">
                  <div className="profile-name">{`${props.fname.link} ${props.lname.link}`}</div>
                  <div className="profile-designation">{props.title.link}</div>
                </div>
              </div>
              <div className="align-content-box">
                <div className="qrDiv">
                  <div className="qrcode">
                    {loading ? (
                      <>
                        <QRCode
                          value={vCards.getFormattedString()}
                          size={136}
                        />
                      </>
                    ) : (
                      <>
                        <div className="loader-center">
                          <img
                            src={loader}
                            alt="loading..."
                            className="loader"
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <InfoPart
                  icon={emailIcon}
                  title={"email"}
                  titleContent={props.email.link}
                />
                <InfoPart
                  icon={phoneIcon}
                  title={"phone"}
                  titleContent={
                    props.phone.link !== undefined
                      ? `${props.phone.countryCode} - ${props.phone.link}`
                      : "N/A"
                  }
                />

                {props.org.link && (
                  <InfoPart
                    icon={organisationIcon}
                    title={"organization"}
                    titleContent={props.org.link}
                  />
                )}
                <div className="line"></div>
                <button className="download-vcard" onClick={downloadVCard}>
                  Download V card
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const InfoPart = (props) => {
  return (
    <div className="info">
      <div className="icon">
        <ImageComponent
          image={{ src: props.icon, alt: "icon" }}
        ></ImageComponent>
      </div>
      <div className="details">
        <div className="title">{props.title}</div>
        <div className="title-content">{props.titleContent}</div>
      </div>
    </div>
  );
};

const ImageComponent = ({ image }) => (
  <>
    <LazyLoadImage
      alt={image.alt}
      src={image.src} // use normal <img> attributes as props
    />
    <span>{image.caption}</span>
  </>
);
